module.exports = __webpack_public_path__ + "images/help/road-3e45a9f24213c2b1140910572946c41c.png";